import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex, Table, Tbody, Td,
  Text, Tr
} from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../utils";
import { NumberField } from "../../../../../components/NumberField";
import { scopeThreeCategories } from "../../../../Reports/CompanyEmissionsDashboard/components/helpers";
import { Fragment } from "react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScopeThreeCategoriesDonutChart } from "./index";

function RevenueReport({ data, sourcingCompanyName, containerFlow, showScopeTotals = true }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard.charts"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const scopeThreeCategoriesData = data.scopeThree;
  const scopeThreeTotalEmissions = data.scope3TotalCo2Emissions;

  const getDonutChartData = (totalEmissionsData, scopeThreeTotal) => {
    return scopeThreeCategories
      .filter((el) =>
        totalEmissionsData[`category${el.index}TotalCo2Emissions`] &&
        totalEmissionsData[`category${el.index}TotalCo2Emissions`] > 0)
      .map(el => {
        return {
          ...el,
          id: el.index,
          label: globalTranslation(`dataEntryPlanning.modal.categories.${el.translationKey}`),
          value: totalEmissionsData[`category${el.index}TotalCo2Emissions`]
        };
      });
  };

  const getApportionedValue = (totalValue, apportionedValue) => {
    return totalValue && typeof totalValue !== "undefined" ? (
      <Text fontSize="md" fontWeight="600">
        ({sourcingCompanyName} {t("associatedEmissions")}: <b>{apportionedValue?.toLocaleString("en-GB", { maximumFractionDigits: 4 }) ?? "n/a"}</b>)
      </Text>
    ) : "";
  };

  return (
    <Flex height="100%" flexFlow="column" gap={4}>
      {showScopeTotals ?
        <Box width={"100%"} flexGrow="1">
          <Accordion defaultIndex={[0]} allowToggle>
            <AccordionItem>
              <h2>
                <AccordionButton paddingInlineStart={containerFlow === "row" ? 2 : 0}>
                  <Box as="span" flex="1" textAlign="left">
                    <Text fontSize="xl" fontWeight="600">
                      {translateSubElementString("companyEmissionsDashboard.totalEmissions.allScopesTotals")}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Flex gap={4} flexFlow="column" marginTop={5}>
                  <Flex alignItems="center" gap={2}>
                    <Text fontSize="lg">
                      {t("scope")} 1:
                    </Text>
                    <NumberField fontSize="2xl" fontWeight="bold" value={data.scope1TotalCo2Emissions} />
                    {getApportionedValue(data.scope1TotalCo2Emissions, data.scope1ApportionedCo2Emissions)}
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Text fontSize="lg">
                      {t("scope")} 2:
                    </Text>
                    <NumberField fontSize="2xl" fontWeight="bold" value={data.scope2TotalCo2Emissions} />
                    {getApportionedValue(data.scope2TotalCo2Emissions, data.scope2ApportionedCo2Emissions)}
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Text fontSize="lg">
                      {t("scope")} 3:
                    </Text>
                    <NumberField fontSize="2xl" fontWeight="bold" value={scopeThreeTotalEmissions} />
                    {getApportionedValue(data.scope3TotalCo2Emissions, data.scope3ApportionedCo2Emissions)}
                  </Flex>
                </Flex>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box> : null
      }
      <Flex height="100%" flexFlow={containerFlow} gap={containerFlow === "row" ? 0 : 4}>
        <Box
          width={containerFlow === "row" ? "50%" : "100%"}
          flexGrow="1" paddingInline={containerFlow === "row" ? 2 : 0}
          borderRight={containerFlow === "row" ? "1px solid #d4d9e0" : null}
        >
          <Flex justifyContent="space-between">
            <Text fontSize="xl" fontWeight="600">
              {translateSubElementString("companyEmissionsDashboard.totalEmissions.scopeThreeCategories")}
            </Text>
          </Flex>
          <Table variant="striped" colorScheme="gray" marginTop={5} size="sm">
            <Tbody>
              {scopeThreeCategories.map((category) => {
                return <Fragment key={`${category.numberKey}-${category.translationKey}`}>
                  <Tr fontSize="xs">
                    <Td>
                      {category.index}. {globalTranslation(`dataEntryPlanning.modal.categories.${category.translationKey}`)}
                    </Td>
                    <Td isNumeric>
                      {
                        scopeThreeCategoriesData[`category${category.index}TotalCo2Emissions`]?.toLocaleString("en-GB", { maximumFractionDigits: 4 }) ?? ""
                      }
                    </Td>
                  </Tr>
                </Fragment>;
              })}
            </Tbody>
          </Table>
        </Box>
        <Box
          width={containerFlow === "row" ? "50%" : "100%"}
          flexGrow="1" paddingInlineStart={containerFlow === "row" ? 5 : 0}
          paddingInlineEnd={0}
        >
          <Text fontSize="xl" fontWeight="600">
            {t("categoriesDonutChartTitle")}
          </Text>
          <Box marginTop={10}>
            <Box height={"300px"}>
              <ScopeThreeCategoriesDonutChart
                data={getDonutChartData(scopeThreeCategoriesData, scopeThreeTotalEmissions)}
              />
            </Box>
            <Box marginTop={5}>
              <Text fontSize="lg">{t("categories")}:</Text>
              <Flex marginTop={2} gap={4} flexWrap="wrap">
                {scopeThreeCategories.map((cat, index) => {
                  return <Flex key={`legend-${cat.numberKey}`} gap={1} alignItems="center">
                    <Box width={5} height={5} borderRadius="50%" backgroundColor={cat.color} />
                    <Text>{index + 1}</Text>
                  </Flex>;
                })}
              </Flex>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default RevenueReport;